/**
 * Initialise Swiper on any `.js-shows-swiper` element found in the page.
 * Usage in template:
 *
 *   <div class="swiper js-shows-swiper">
 *     <div class="swiper-wrapper">
 *       <div class="swiper-slide">…</div>
 *     </div>
 *     <div class="swiper-pagination"></div>
 *     <div class="swiper-button-prev"></div>
 *     <div class="swiper-button-next"></div>
 *   </div>
 */
export function initShowsSwiper( Swiper, modules ) {
	const containers = document.querySelectorAll( '.js-shows-swiper' );
	if ( ! containers.length ) return;

	containers.forEach( ( el ) => {
		new Swiper( el, {
			modules: Object.values( modules ),
			slidesPerView: 1.25,
			watchOverflow: true,
			spaceBetween: 40,
			pagination: {
				el: el.querySelector( '.swiper-pagination' ),
				clickable: true,
			},
			navigation: {
				nextEl: el.querySelector( '.swiper-button-next' ),
				prevEl: el.querySelector( '.swiper-button-prev' ),
			},

			// Accessibilité Swiper (A11y)
			a11y: {
				enabled: true,

				// Libellés/annonces (à adapter au wording de ton projet)
				prevSlideMessage: 'Diapositive précédente',
				nextSlideMessage: 'Diapositive suivante',
				firstSlideMessage: 'Première diapositive',
				lastSlideMessage: 'Dernière diapositive',

				paginationBulletMessage: 'Aller à la diapositive {{index}}',
				slideLabelMessage: '{{index}} / {{slidesLength}}',
			},

				breakpoints: {
				1024: { slidesPerView: 3.25 },
				640:  { slidesPerView: 2.25 },
			},
		});

	} );
}

export function initSponsorsSwiper( Swiper, modules ) {
	const containersSponsors = document.querySelectorAll( '.js-sponsors-swiper' );
	if ( ! containersSponsors.length ) return;

	containersSponsors.forEach( ( el ) => {
		new Swiper( el, {
			modules: Object.values( modules ),
			slidesPerView: 2.5,
			watchOverflow: true,
			spaceBetween: 40,
			pagination: {
				el: el.querySelector( '.swiper-pagination' ),
				clickable: true,
			},
			navigation: {
				nextEl: el.querySelector( '.swiper-button-next' ),
				prevEl: el.querySelector( '.swiper-button-prev' ),
			},
			breakpoints: {
				1024: { slidesPerView: 5.5 },
				640:  { slidesPerView: 3.5 },
			},
		} );
	} );
}
